import { ClaimUserMembershipGetPaginatedResponse } from 'common/services/api/claimUserMembership/claimUserMembership.api';
import { IAPIRoleUserMembershipGetPaginatedSingleResponse } from 'common/services/api/RoleUserMembership/RoleUserMembership.api';
import { TenantUserMembershipGetPaginatedSingleResponse } from 'common/services/api/TenantUserMembership/TenantUserMembershipApiTypeDefs';
import { APIUserGroupsUsersGetSingleResponse } from 'common/services/api/UserGroupsUsers/userGroupsUsers.api';

import { dateToFrontEndFormat } from './dateHelpers';
import { _calculateStatusTooltipMessage, getUTMsStatusTooltipProps } from './statusHelpers';

export const mapUserMembershipDetails = (item: APIUserGroupsUsersGetSingleResponse | ClaimUserMembershipGetPaginatedResponse |
    IAPIRoleUserMembershipGetPaginatedSingleResponse | TenantUserMembershipGetPaginatedSingleResponse) => {
    const statusTooltipProps = getUTMsStatusTooltipProps(item);

    return {
        id: item.userId || '',
        firstName: item.profile?.firstName || 'Unknown',
        lastName: item.profile?.lastName || 'User',
        principalName: item.profile?.principalName || 'Unknown',
        email: item.profile?.email,
        companyKey: item.profile?.companyKey || '',
        oasysId: item?.oasysId ?? '',
        status: item.status,
        startDate: dateToFrontEndFormat(item.startDate),
        endDate: dateToFrontEndFormat(item.endDate),
        tooltipMessage: _calculateStatusTooltipMessage(statusTooltipProps)
    };
};
